module.exports = __webpack_public_path__ + "static/media/cover-shipping-containers.01417c93.jpg";